$(document).ready(function(){
  $('.quotes-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      dots: true,
      infinite: true,
      autoplay: false,
      responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
    ]
  });
});